/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types';
import {
  Modal,
  Button,
  ShortText,
  Icon,
} from 'components/common';
import successImage from 'assets/jobs/success-draft-job.png';

import {
  modalStyles,
  contentStyles,
  imageContainerStyles,
  descriptionContainerStyles,
  buttonContainerStyles,
} from './SuccessChangeStatusModal.styles';

const SuccessDraftJobModal = ({
  isSuccessStatusModalOpen,
  setSuccessStatusModal,
  handleSuccessChangeStatusModal,
}) => (
  <Modal
    isModalOpen={isSuccessStatusModalOpen}
    setModal={setSuccessStatusModal}
    styles={modalStyles}
  >
    <div css={contentStyles}>
      <Icon onClick={handleSuccessChangeStatusModal} name="times" />
      <div css={imageContainerStyles}>
        <img src={successImage} alt="success-post-job" />
      </div>
      <div css={descriptionContainerStyles}>
        <ShortText>Job Status Has Been Changed</ShortText>
        <ShortText>
          Thank you, your existing Fullstack Developer Job has been changed.
          You can check the information details from jobs page
        </ShortText>
      </div>
      <div css={buttonContainerStyles}>
        <Button
          type="button"
          onClick={handleSuccessChangeStatusModal}
        >
          go to job page
        </Button>
      </div>
    </div>
  </Modal>
);
SuccessDraftJobModal.propTypes = {
  isSuccessStatusModalOpen: PropTypes.bool.isRequired,
  setSuccessStatusModal: PropTypes.func.isRequired,
  handleSuccessChangeStatusModal: PropTypes.func.isRequired,
};

export default SuccessDraftJobModal;
